import { render, staticRenderFns } from "./ProcessingCostsView.vue?vue&type=template&id=98acd37e&scoped=true"
import script from "./ProcessingCostsView.vue?vue&type=script&setup=true&lang=js"
export * from "./ProcessingCostsView.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ProcessingCostsView.vue?vue&type=style&index=0&id=98acd37e&prod&lang=css"
import style1 from "./ProcessingCostsView.vue?vue&type=style&index=1&id=98acd37e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98acd37e",
  null
  
)

export default component.exports